import veritoneApi from './veritoneApi';
import { JOB_PREFIX, TDO_PREFIX } from '../state/modules/app/playout/constant';
import { assetPlayoutError } from './playoutUploaderApi.js';
import { get, chunk, uniq, isEmpty } from 'lodash';

function genGetJobStatusGraphQl(jobIds) {
	const mapJobIdQuery = jobIds.map( jobId => {
		const jobIdKey = `${JOB_PREFIX}${jobId}`;
		return `${jobIdKey}: job(id: "${jobId}") {
			tasks {
				records {
					status
				}
			}
		}`		
	})
	return `{
		${mapJobIdQuery}
	}`
}

export function getJobStatusPlayout(urlApi, jobIds) {
	if(isEmpty(jobIds)){
		return {} ;
	}
	return veritoneApi(urlApi.graphql)
		.post(
			'',
			{ query: genGetJobStatusGraphQl(jobIds) }
		)
		.then(response => {
			const data = get(response, 'data.data' , null);
			return data;
		}
		)
		.catch(error => ({
			error: true,
			...error
		}))  
}

export function getJobStatusApi(urlApi, jobIds, chunkSize = 50) {
	const uniqJobIds = uniq(jobIds);
	if(uniqJobIds.length > chunkSize){
		return new Promise( async (resolve, reject) => {
			const result = await getJobStatusByChunk(urlApi, uniqJobIds, chunkSize);
			resolve(result);
		  })
	}else {
		return getJobStatusPlayout(urlApi, uniqJobIds);
	}
}

export async function getJobStatusByChunk(urlApi, jobIds, chunkSize){
	const jobIdByChunk = chunk(jobIds, chunkSize);
	const chunkNumberToLoad = 10;
	let responseByChunk = [];
	while(jobIdByChunk.length > 0){
		const chunkToLoad = jobIdByChunk.splice(0, chunkNumberToLoad);
		const results =  await Promise.all(chunkToLoad.map(jobIds => {
			return getJobStatusPlayout(urlApi, jobIds);
		  }))
		.then(responses => responses)
		responseByChunk = [...responseByChunk, ...results];
	}
	const data = processJobIdHashMap(responseByChunk);
	return  data ;
}

function processJobIdHashMap(responseByChunk) {
	let statusHashMap = {};
	for(let i = 0; i < responseByChunk.length; i++) {
		const response = responseByChunk[i];
		statusHashMap = { ...statusHashMap, ...response }
	}
	return statusHashMap;
}

function genGetTDOIdStatusGraphQl(completedTDOIds) {
	const mapTDOIdStatusErrorQuery = completedTDOIds.map( completedTDOId => {
		const TDOIdKey = `${TDO_PREFIX}${completedTDOId}`;
		return ` ${TDOIdKey}: temporalDataObject(id: "${completedTDOId}") {
			assets(assetType: "${assetPlayoutError}") {
				records {
					assetType
					signedUri
				}
			}
		}`
	})
	return `{
		${mapTDOIdStatusErrorQuery}
	}`
}

export function checkErrorStatusPlayoutApi(urlApi, completedTDOIds) {
	if(isEmpty(completedTDOIds)){
		return {};
	}
	return veritoneApi(urlApi.graphql)
	.post(
		'',
		{ query: genGetTDOIdStatusGraphQl(completedTDOIds) }
	)
	.then(response => {
		const data = get(response, 'data.data' , null);
		return data;
	}
	)
	.catch(error => ({
		error: true,
		...error
	}))

}


